export default "__VITE_ASSET__BX0nMwK3__"